<template>
  <div class="participation-report-wrap">
    <div class="paticipation-wrap">
      <v-row class="am-participation-wrap">
        <v-col class="pa-0">
          <div class="am-card">
            <div class="am-card-header">
              <h3 class="am-card-title">
                <!-- <span>&nbsp;</span> -->
                <span v-if="reportToggle">Employee participation rate
                  <div class="info-icon pt-5" name="Engagement7" style="display: initial;">
                    <i class="las la-info-circle ls-4"></i>
                  </div>
                  <tippy to="Engagement7"
                    interactive="true"
                    theme="light amara"
                    class="am-tool"
                    :allowHTML="true"
                    arrow
                    placement="right"
                  >
                    <h3 class="am-card-title pr-1"><b>Employee participation rate</b></h3>
                    <p>
                      Get a real-time analysis on the total
number of employees completing chats vis-à-vis the employees reached
out to over a period of time.
                    </p>
                  </tippy>
                </span>
                <span v-else>Chat response rate
                  <div class="info-icon pt-5" name="Engagement6" style="display: initial;">
                    <i class="las la-info-circle ls-4"></i>
                  </div>
                  <tippy to="Engagement6"
                    interactive="true"
                    theme="light amara"
                    class="am-tool"
                    :allowHTML="true"
                    arrow
                    placement="right"
                  >
                    <h3 class="am-card-title pr-1"><b>Chat response rate</b></h3>
                    <p>
                      It is the number of chats completed by
employees across multiple touchpoints vis-à-vis the total number of
chats not started & in progress in real time. Point to be noted here is
that, a particular employee may receive multiple chats from Amara
depending upon the touchpoints completed.
                    </p>
                  </tippy>
                </span>
              </h3>
              <div>
                <v-switch
                  v-model="reportToggle"
                  inset
                  hide-details
                  color="primary"
                  class="ma-0 pa-0 report-switch"
                ></v-switch>
              </div>
            </div>
            <div class="toggle-sub">
              <span>Toggle to view&nbsp;</span>
              <span v-if="reportToggle">chat response rate</span>
              <span v-else>employee participation rate</span>
            </div>
            <div v-if="stats">
              <div class="card_img participation">
                <div class="stat-score" v-if="stats.chat_response_rate">
                  {{stats.chat_response_rate}}%
                </div>
                <div class="stat-score" v-else>
                  0
                </div>
              </div>
              <p class="am-card-sub">
                <span>Aggregated&nbsp;</span>
                <span v-if="reportToggle">participation rate</span>
                <span v-else>response rate</span>
              </p>
              <div class="participation-stats-wrap">
                <div class="p-stats-wrap">
                  <div class="p-stats">
                    <!-- <div class="score-bullet bullet-1">
                    </div> -->
                    <div class="p-score" :class="reportToggle ? 'link' : ''" v-if="stats.initiated"
                      @click="viewEmployees('initiated')"
                    >{{stats.initiated}}</div>
                    <div class="p-score" :class="reportToggle ? 'link' : ''" v-else>0</div>
                  </div>
                  <div class="p-title">Not started</div>
                </div>
                <div class="p-stats-wrap">
                  <div class="p-stats">
                    <!-- <div class="score-bullet bullet-2">
                    </div> -->
                    <div class="p-score" :class="reportToggle ? 'link' : ''" v-if="stats.inProgress"
                      @click="viewEmployees('inProgress')"
                    >{{stats.inProgress}}</div>
                    <div class="p-score" :class="reportToggle ? 'link' : ''" v-else>0</div>
                  </div>
                  <div class="p-title">In progress</div>
                </div>
                <div class="p-stats-wrap">
                  <div class="p-stats">
                    <!-- <div class="score-bullet bullet-3">
                    </div> -->
                    <div class="p-score" :class="reportToggle ? 'link' : ''" v-if="stats.completed"
                      @click="viewEmployees('completed')"
                    >{{stats.completed}}</div>
                    <div class="p-score" :class="reportToggle ? 'link' : ''" v-else>0</div>
                  </div>
                  <div class="p-title">Completed</div>
                </div>
              </div>
            </div>
            <div v-else class="am-no-data">{{noDataText}}</div>
          </div>
          <div class="response-rate-graph pt-4">
            <div class="rate-title">
              <span>Gender wise&nbsp;</span>
              <span v-if="reportToggle">employee participation</span>
              <span v-else>chat response</span>
              <br>
              <span>rate</span>
              <span class="gender-action" @click="viewGender">
                <v-icon class="" color="primary">las la-external-link-alt</v-icon>
                <span class="font-weight-bold">View more</span>
              </span>
            </div>
            <div v-if="!chartData || chartData.length === 0" class="am-no-data">
              {{noDataText}}
            </div>
            <div v-if="isLoading && chartData && chartData.length !== 0" style="position: absolute;left:35%;top:40%">
              <v-btn :loading="true" text x-large fab></v-btn>
              <div class="pl-1">Loading...</div>
            </div>
            <div id="responseRate" v-show="chartData && Object.keys(chartData).length > 0"></div>
          </div>
        </v-col>
      </v-row>
    </div>
    <chatResponseRateEmployees
      ref="chatResponseRateEmployees"
    ></chatResponseRateEmployees>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs-ext/plugin/customParseFormat';

import chatResponseRateEmployees from '../dialogs/chat-response-rate-employees';

import OverviewMixin from './overview-mixin';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
am4core.useTheme(am4themes_animated);

export default {
  name: 'ParticipationReport',

  mixins: [OverviewMixin],

  components: {
    chatResponseRateEmployees
  },

  data () {
    return {
      reportToggle: true,
      stats: {},
      chartData: [],
      isLoading: true
    };
  },

  mounted () {
    this.initStatData();
  },

  beforeDestroy () {
    am4core.disposeAllCharts();
  },

  watch: {
    reportToggle () {
      this.initStatData();
    },
    dashboardData: {
      deep: true,
      handler () {
        this.initStatData();
      }
    }
    // chartData: {
    //   deep: true,
    //   handler () {
    //     setTimeout(() => {
    //       if (this.chartData) {
    //         this.createResponseRate();
    //       } else {
    //         this.chartData = [];
    //         this.isLoading = false;
    //       }
    //     }, 50);
    //   }
    // }
  },

  methods: {
    viewGender () {
      const temp = {
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/analytics/diversity-report',
        query: {
          filters: JSON.stringify(temp),
          stage__title__in: this.$route.query && this.$route.query.stage ? this.$route.query.stage : undefined
        }
      }).catch(() => {});
    },
    viewEmployees (chatStatus) {
      if (this.reportToggle) {
        const employeeFilters = {
          ...this.updateDashboardFilters,
          user_session__status__in: chatStatus || undefined
        };
        if (this.$route.query && this.$route.query.stage) {
          employeeFilters.user_session__stage__title = this.$route.query.stage;
        }
        this.$store.dispatch('updateEmployeeFilters', employeeFilters);
        this.$nextTick(() => {
          this.$router.push({
            path: '/employees',
            query: {
              filters: JSON.stringify(employeeFilters)
            }
          }).catch(() => {});
        });
      }
    },
    initStatData () {
      if (this.reportToggle) {
        this.stats = this.dashboardData.user_participation_stats;
        this.chartData = this.dashboardData.user_participation_trends;
      } else {
        this.stats = this.dashboardData.chat_response_stats;
        this.chartData = this.dashboardData.chat_response_trends;
      }
      const formattedData = [];
      if (this.chartData) {
        this.$lodash.each(this.chartData, (v, key) => {
          formattedData.push({
          // month: v.month,
            month: dayjs(key).format('MMM \'YY'),
            female: v && v.female && v.female.chat_response_rate ? v.female.chat_response_rate : '',
            femaleChatInitiated: v && v.female && v.female.chats_initiated ? v.female.chats_initiated : '',
            femaleChatCompleted: v && v.female && v.female.chats_completed ? v.female.chats_completed : '',
            male: v && v.male && v.male.chat_response_rate ? v.male.chat_response_rate : '',
            maleChatInitiated: v && v.male && v.male.chats_initiated ? v.male.chats_initiated : '',
            maleChatCompleted: v && v.male && v.male.chats_initiated ? v.male.chats_completed : '',
            overall: v && v.overall && v.overall.chat_response_rate ? v.overall.chat_response_rate : '',
            overallChatInitiated: v && v.overall && v.overall.chats_initiated ? v.overall.chats_initiated : '',
            overallChatCompleted: v && v.overall && v.overall.chats_initiated ? v.overall.chats_completed : ''
          });
        });
        this.isLoading = true;
        setTimeout(() => {
          this.createResponseRate(formattedData);
        }, 50);
      }
      this.$forceUpdate();
    },
    createResponseRate (val) {
      // console.log('val', val);
      // Create chart instance
      var chart = am4core.create('responseRate', am4charts.XYChart);
      chart.legend = new am4charts.Legend();
      // Add data
      chart.data = val;
      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'month';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 20;
      // categoryAxis.renderer.labels.template.rotation = 55;
      categoryAxis.renderer.cellStartLocation = 0.1;
      categoryAxis.renderer.cellEndLocation = 0.8;

      const label = categoryAxis.renderer.labels.template;
      // label.dx = 15;
      label.truncate = true;
      label.fontSize = 10;
      // label.wrap = true;
      label.maxWidth = 50;
      label.hideOversized = false;

      // eslint-disable-next-line no-unused-vars
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minGridDistance = 20;
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.strictMinMax = true;
      // Create series2
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = 'overall';
      series.dataFields.categoryX = 'month';
      series.name = 'Overall';
      series.columns.template.fillOpacity = 1;
      series.strokeWidth = 0;
      // series.columns.template.fill = '#050550';
      // series.columns.template.fill = '#bbbbbb';
      series.columns.template.fill = '#818385';
      series.columns.template.tooltipHTML = `<center><strong>Overall: {categoryX}</strong></center>
      <hr />
      <table>
      <tr>
        <th align="left">Chats Initiated</th>
        <td>{overallChatInitiated}</td>
      </tr>
      <tr>
        <th align="left">Chats Completed</th>
        <td>{overallChatCompleted}</td>
      </tr>
      </table>`;

      // Create series
      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.dataFields.valueY = 'male';
      series1.dataFields.categoryX = 'month';
      series1.name = 'Male';
      series1.columns.template.fillOpacity = 1;
      series1.strokeWidth = 0;
      series1.columns.template.fill = '#050550';
      series1.columns.template.tooltipHTML = `<center><strong>Male: {categoryX}</strong></center>
      <hr />
      <table>
      <tr>
        <th align="left">Chats Initiated</th>
        <td>{maleChatInitiated}</td>
      </tr>
      <tr>
        <th align="left">Chats Completed</th>
        <td>{maleChatCompleted}</td>
      </tr>
      </table>`;

      // Create series1
      var series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = 'female';
      series2.dataFields.categoryX = 'month';
      series2.name = 'Female';
      series2.columns.template.fillOpacity = 1;
      series2.strokeWidth = 0;
      // series2.columns.template.fill = '#a09de0';
      series2.columns.template.fill = '#810052';
      series2.columns.template.tooltipHTML = `<center><strong>Female: {categoryX}</strong></center>
      <hr />
      <table>
      <tr>
        <th align="left">Chats Initiated</th>
        <td>{femaleChatInitiated}</td>
      </tr>
      <tr>
        <th align="left">Chats Completed</th>
        <td>{femaleChatCompleted}</td>
      </tr>
      </table>`;
      chart.preloader.disabled = true;
      const that = this;
      chart.events.on('ready', function (ev) {
        that.isLoading = false;
        // hideIndicator();
      });
      // var indicator;
      // var indicatorInterval;
      // function showIndicator () {
      //   if (!indicator) {
      //     indicator = chart.tooltipContainer.createChild(am4core.Container);
      //     indicator.background.fill = am4core.color('#fff');
      //     indicator.background.fillOpacity = 0.8;
      //     indicator.width = am4core.percent(100);
      //     indicator.height = am4core.percent(100);
      //     var indicatorLabel = indicator.createChild(am4core.Label);
      //     indicatorLabel.text = 'Loading...';
      //     indicatorLabel.align = 'center';
      //     indicatorLabel.valign = 'middle';
      //     indicatorLabel.fontSize = 12;
      //     indicatorLabel.dy = 50;
      //     var hourglass = indicator.createChild(am4core.Image);
      //     hourglass.href = 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/t-160/hourglass.svg';
      //     hourglass.align = 'center';
      //     hourglass.valign = 'middle';
      //     hourglass.horizontalCenter = 'middle';
      //     hourglass.verticalCenter = 'middle';
      //     hourglass.scale = 0.5;
      //   }
      //   indicator.hide(0);
      //   indicator.show();
      //   clearInterval(indicatorInterval);
      //   indicatorInterval = setInterval(function () {
      //     hourglass.animate([{
      //       from: 0,
      //       to: 360,
      //       property: 'rotation'
      //     }], 2000);
      //   }, 3000);
      // }
      // function hideIndicator () {
      //   indicator.hide();
      //   clearInterval(indicatorInterval);
      // }
      // showIndicator();
    }
  }
};
</script>

<style lang="scss" scoped>
.participation-report-wrap {
  margin-top: 12px;
  .am-no-data {
    top: 60%;
    position: absolute;
    // height: 18rem;
  }
  .paticipation-wrap {
    background-color: var(--bg);
    padding: 16px;
    // min-height: 41.5rem;
    min-height: 42rem;
    border-radius: 6px;
    // box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
    box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    .am-participation-wrap {
      margin: 0;
      .am-card {
        position: relative;
        height: 16rem;
        .card_img {
          width:100%;
          position: relative;
          padding: 0 16px;
          .stat-score {
            text-align: center;
            margin: 0 auto;
            font-size: 3rem;
            color: var(--color-text);
          }
        }
        .am-card-header {
          display: flex;
          justify-content: space-between;
          .am-card-title {
            color: var(--color-text);
            font-size: var(--content-size);
            text-align: left;
          }
        }
        .toggle-sub {
          padding: 12px 0px 8px 0;
          font-size: var(--content-sub-size);
          color: var(--color-text);
          // color: var(--color-palceholder);
        }
        .am-card-sub {
          font-size: var(--content-sub-size);
          color: var(--color-text);
          text-align: center;
          margin: 0;
        }
        .participation-stats-wrap {
          display: flex;
          justify-content: space-evenly;
          .p-stats-wrap {
            padding: 12px;
            .p-stats {
              // display: flex;
              // align-items: center;
              .score-bullet {
                height: 18px;
                width: 18px;
                border-radius: 50%;
                background: #ffffff;
                &.bullet-1 {
                  border: 5px solid var(--primary-color-2);
                }
                &.bullet-2 {
                  border: 5px solid var(--primary-color-4);
                }
                &.bullet-3 {
                  border: 5px solid var(--primary-color-6);
                }
              }
              .p-score {
                font-size: var(--heading-size);
                // padding-left: 4px;
                text-align: center;
                font-weight: var(--heading-weight);
                &.link {
                  color: var(--content-color);
                  cursor: pointer;
                  text-decoration: underline;
                  &:hover {
                    color: var(--primary-color);
                  }
                }
              }
            }
            .p-title {
              color: var(--color-text);
              font-size: var(--content-sub-size);
              width: 100%;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
      }
      .response-rate-graph {
        position: relative;
        height: 23rem;
        .rate-title {
          color: var(--color-text);
          font-size: var(--content-size);
          text-align: left;
        }
        #responseRate {
          margin-left: -25px;
          height: 19rem;
        }
        .gender-action {
          cursor: pointer;
          color: var(--primary-color);
        }
      }
    }
  }
}
</style>

<style lang="scss">
.report-switch .v-input--selection-controls__input div {
  color: var(--primary-color) !important;
}
</style>

<style scoped>
.paticipation-wrap[min-width~="230px"] {
  min-height: 43.7rem !important;
}
.paticipation-wrap[min-width~="230px"] .p-stats-wrap {
  padding: 8px !important;
}
.paticipation-wrap[min-width~="230px"] .p-stats-wrap {
  padding: 8px !important;
}
.paticipation-wrap[min-width~="230px"] .p-title {
  font-size: 12px !important;
}
.paticipation-wrap[min-width~="230px"] .p-score {
  font-size: 16px !important;
}
.paticipation-wrap[min-width~="320px"] .p-stats-wrap {
  padding: 16px !important;
}
.paticipation-wrap[min-width~="320px"] .p-stats-wrap {
  padding: 16px !important;
}
.paticipation-wrap[min-width~="320px"] .p-title {
  font-size: 14px !important;
}
.paticipation-wrap[min-width~="320px"] .p-score {
  font-size: 18px !important;
}
</style>
